<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{info.client_mobile}}线索客户详情</h1>
            <el-form class="form-container" :model="info"  ref="userInfoForm"
            >
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">站点</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.site_name" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">区域</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.area_name_str" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">电话</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.client_mobile" :disabled="isShow ? true : false">
                            </el-input>
                            <el-button type="primary" :disabled="false" @click="addBlack(info.client_mobile)" v-permission="'operating.blacklist.mobile.create'">添加黑名单</el-button>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">楼盘名</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.house_name_str" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">来源方式</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.source_name" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">页面位置</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.page_str" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">来源终端</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.terminal_name" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">来源渠道</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.channel_name" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">IP</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder=""  v-model="info.ip" :disabled="isShow ? true : false">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">其他信息</span>
                    </div>
                    <div class="form-input-item suffix-show">
                        <el-form-item label="">
                            <el-input placeholder="" type="textarea" class="input-control" v-model="info.extra" :disabled="isShow ? true : false"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div class="form-button">
                <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "detail",
        components: {
            PopoverRight
        },
        methods : {
            open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
                this.info.extra = ''
                this.info.extra += 'URL:' + this.info.source_url + "\n"
                //this.info.extra += '竞价来源:' + this.info.promote_url + "\n"
                this.info.extra += '备注:' + this.info.remark + "\n"
                this.info.extra += '客户意向最低价格:' + this.info.price_min + "\n"
                this.info.extra += '客户意向最高价格:' + this.info.price_max + "\n"
                if (this.info.extra_json_arr.length > 0) {
                    this.info.extra_json_arr.forEach(el => {
                        this.info.extra += el.key + ":" +el.value + "\n"

                    });
                }
                this.isShow = 1
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.info = {}
                this.isShow = 0
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            // 添加黑名单
            addBlack(phone){
                this.hide();
                this.$emit("add_black",phone)
            }
        },
        data () {
            return {
                info: {
                },
                isShow : 0,
            }
        }
    }
</script>

<style lang="less" scoped>
 /deep/ .el-form-item--medium .el-form-item__content{
    display: flex;
}
</style>